import React, { useEffect, useContext}from "react";
import useForm from 'react-hook-form';
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';

// ui components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated } from "beaktShared/helpers/masks";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function VendaEstabelecimento({item, CallHandleVoltar, CallUpdateItem}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 8000);       
  };

  const { register, handleSubmit, setValue, errors, getValues } = useForm({mode: "onChange"}); 
  const [loading, setLoading] = React.useState(false);

  const [listSelectEspecialidades, setlistSelectEspecialidades] = React.useState([]);
  const [listSelectEspecialidadesSelected, setlistSelectEspecialidadesSelected] = React.useState([]);
  const [especialidades, setespecialidades] = React.useState([]);
  const [loadingSelectEspecialidades, setloadingSelectEspecialidades] = React.useState(false);
  const loadEspecialidades = () =>{   
    setloadingSelectEspecialidades(true);   
    let endpoint = "especialidades/ativos/byfranquia/" + session.franquiaId;  
      UseGetApiSimple(endpoint).then(result=>{      
          if(result.status !== 200)
          {                                     
              showNotification(t('error_message.unable_to_load_products')+"!",'danger'); 
              setloadingSelectEspecialidades(false); 
              return false; 
          }     
         
          setlistSelectEspecialidades(result.data);  
          setloadingSelectEspecialidades(false); 
          return true;                
      });  
  }
  const handleEspecialidadeChange = event => {
      let value = event
      let data = getValues()

      let lstsAdd = [];
      let lstSelect = [];
      value.map(item =>{
          lstsAdd.push(item.especialidadeId); 
          
          lstSelect.push({
            especialidadeId: item.especialidadeId,
            estabelecimentoId:data.estabelecimentoId
          });                   
      });
      setespecialidades(lstsAdd); 
      setlistSelectEspecialidadesSelected(lstSelect);

  }
  const handleClickSelecionarTodosEspecialidades = () =>{
      
      let data = getValues()
      let lstsAdd = [];
      let lstSelect = [];
      listSelectEspecialidades.map(item =>{
          lstsAdd.push(item.especialidadeId); 
         
          lstSelect.push({
            especialidadeId:item.especialidadeId,
            estabelecimentoId: data.estabelecimentoId
          });                   
      });
      setespecialidades(lstsAdd); 
      setlistSelectEspecialidadesSelected(lstSelect);
  }

  const [listSelectProdutos, setlistSelectProdutos] = React.useState([]);
  const [listSelectProdutosSelected, setlistSelectProdutosSelected] = React.useState([]);
  const [produtos, setprodutos] = React.useState([]);
  const [produtosCSV, setprodutosCSV] = React.useState([]);

  const [loadingSelectProdutos, setloadingSelectProdutos] = React.useState(false);
  const loadProdutos = () =>
  {  
    setloadingSelectProdutos(true);   
    let endpoint = "produtos/ativos/byfranquia/" + session.franquiaId;  
    UseGetApiSimple(endpoint).then(result=>{      
        if(result.status !== 200)
        {                                     
            showNotification(t('error_message.unable_to_load_products')+"!",'danger'); 
            setloadingSelectProdutos(false); 
            return false;  
        }     

        setlistSelectProdutos(result.data);  
        setloadingSelectProdutos(false); 
        return true;              
    });  
  }

  const handleProdutoChange = event => {
      let value = event
      let data = getValues()

      let lstsAdd = [];
      let lstSelect = [];
      value.map(item =>{
          lstsAdd.push(item.produtoId); 
          
          lstSelect.push({
            produtoId: item.produtoId,
            estabelecimentoId:data.estabelecimentoId
          });                   
      });
      setprodutos(lstsAdd); 
      setlistSelectProdutosSelected(lstSelect);

  }
  const handleClickSelecionarTodosProdutos = () =>{
      
      let data = getValues()
      let lstsAdd = [];
      let lstSelect = [];
      listSelectProdutos.map(item =>{
          lstsAdd.push(item.produtoId); 
         
          lstSelect.push({
            produtoId:item.produtoId,
            estabelecimentoId: data.estabelecimentoId
          });                   
      });
      setprodutos(lstsAdd); 
      setlistSelectProdutosSelected(lstSelect);
  }

  const [listSelectServicos, setlistSelectServicos] = React.useState([]);
  const [listSelectServicosSelected, setlistSelectServicosSelected] = React.useState([]);
  const [servicos, setservicos] = React.useState([]);
  const [loadingSelectServicos, setloadingSelecServicos] = React.useState(false);
  const loadServicos = () =>{   
    setloadingSelecServicos(true);   
    let endpoint = "servicos/ativos/byfranquia/" + session.franquiaId;  
      UseGetApiSimple(endpoint).then(result=>{      
          if(result.status !== 200)
          {                                     
              showNotification(t('error_message.could_not_load_services')+"!",'danger'); 
              setloadingSelecServicos(false); 
              return false; 
          }     
          setlistSelectServicos(result.data);  
          setloadingSelecServicos(false); 
          return true;                
      });  
  }
  const handleServicoChange = event => {
      let value = event
      let data = getValues()

      let lstsAdd = [];
      let lstSelect = [];
      value.map(item =>{
          lstsAdd.push(item.servicoId); 
          
          lstSelect.push({
            servicoId: item.servicoId,
            estabelecimentoId:data.estabelecimentoId
          });                   
      });
      setservicos(lstsAdd); 
      setlistSelectServicosSelected(lstSelect);

  }
  const handleClickSelecionarTodosServicos = () =>{
      
      let data = getValues()
      let lstsAdd = [];
      let lstSelect = [];
      listSelectServicos.map(item =>{
          lstsAdd.push(item.servicoId); 
         
          lstSelect.push({
            servicoId:item.servicoId,
            estabelecimentoId: data.estabelecimentoId
          });                   
      });
      setservicos(lstsAdd); 
      setlistSelectServicosSelected(lstSelect);
  }

  const [listSelectPacotes, setlistSelectPacotes] = React.useState([]);
  const [listSelectPacotesSelected, setlistSelectPacotesSelected] = React.useState([]);
  const [pacotes, setpacotes] = React.useState([]);
  const [loadingSelectPacotes, setloadingSelectPacotes] = React.useState(false);
  const loadPacotes = () =>{   
    setloadingSelectPacotes(true);   
    let endpoint = "pacotes/ativos/byfranquia/" + session.franquiaId;  
      UseGetApiSimple(endpoint).then(result=>{      
          if(result.status !== 200)
          {                                     
              showNotification(t('error_message.Unable to load packages')+"!",'danger'); 
              setloadingSelectPacotes(false); 
              return false; 
          }     
          setlistSelectPacotes(result.data);  
          setloadingSelectPacotes(false); 
          return true;                
      });  
  }
  const handlePacoteChange = event => {
      let value = event
      let data = getValues()

      let lstsAdd = [];
      let lstSelect = [];
      value.map(item =>{
          lstsAdd.push(item.pacoteId); 
          
          lstSelect.push({
            pacoteId: item.pacoteId,
            estabelecimentoId:data.estabelecimentoId
          });                   
      });
      setpacotes(lstsAdd); 
      setlistSelectPacotesSelected(lstSelect);

  }
  const handleClickSelecionarTodosPacotes = () =>{
      
      let data = getValues()
      let lstsAdd = [];
      let lstSelect = [];
      listSelectPacotes.map(item =>{
          lstsAdd.push(item.pacoteId); 
         
          lstSelect.push({
            pacoteId:item.pacoteId,
            estabelecimentoId: data.estabelecimentoId
          });                   
      });
      setpacotes(lstsAdd); 
      setlistSelectPacotesSelected(lstSelect);
  }

  useEffect(() => {
    loadEspecialidades();
    loadProdutos();
    loadServicos();
    loadPacotes();
  }, []);

  useEffect(() => {
    if(!item.estabelecimentoId)
        return;       
    
    setValue("estabelecimentoId", item.estabelecimentoId);
    loadEstabelecimentoDetail(item.estabelecimentoId);

  }, [item]);

  const [loadComplete,setloadComplete] = React.useState(false);
  const [dadosEstabelecimento,sedadosEstabelecimento] = React.useState([]);
  const loadEstabelecimentoDetail = (idEstabelecimento) =>{   
    setloadComplete(true);     
    const endPoint = "estabelecimentos/" + idEstabelecimento;
    UseGetApiSimple(endPoint,0).then(result=>{       
        if(result.status !== 200)
        {                                     
            //showNotification(result.message,'danger');  
            setloadComplete(false); 
            return false; 
        }
        
        sedadosEstabelecimento(result.data);
        loadSelectEspecialidadeView(result.data.estabelecimentoEspecialidades);              
        loadSelectProdutoView(result.data.estabelecimentoProdutos); 
        loadSelectServicoView(result.data.estabelecimentoServicos); 
        loadSelectPacoteView(result.data.estabelecimentoPacotes);
        
        if(item.percentualMaximoLimiteDesconto !== null)
          setValue("percentualMaximoLimiteDesconto", transformValueFloattoFormated(item.percentualMaximoLimiteDesconto));

        if(item.percentualMaximoLimiteServico !== null)
          setValue("percentualMaximoLimiteServico", transformValueFloattoFormated(item.percentualMaximoLimiteServico));

        if(item.percentualMaximoLimitePacote !== null)
          setValue("percentualMaximoLimitePacote", transformValueFloattoFormated(item.percentualMaximoLimitePacote));

        setloadComplete(false); 
        return true;                
    });  
  }
  
  const loadSelectEspecialidadeView = (estabelecimentoEspecialidades) =>{        
    if(estabelecimentoEspecialidades===null)
        return;

    setlistSelectEspecialidadesSelected(estabelecimentoEspecialidades);

    let lstAdd = [];
    estabelecimentoEspecialidades.map(item =>{
        lstAdd.push(item.especialidadeId);                 
    });        
    setespecialidades(lstAdd); 
  }

  const loadSelectProdutoView = (estabelecimentoProdutos) =>{        
    if(estabelecimentoProdutos===null)
        return;

    setlistSelectProdutosSelected(estabelecimentoProdutos);

    let lstAdd = [];
    estabelecimentoProdutos.map(item =>{
        lstAdd.push(item.produtoId);                 
    });        
    setprodutos(lstAdd); 
  }

  const loadSelectServicoView = (estabelecimentoServicos) =>{        
    if(estabelecimentoServicos===null)
        return;

    setlistSelectServicosSelected(estabelecimentoServicos);

    let lstAdd = [];
    estabelecimentoServicos.map(item =>{
        lstAdd.push(item.servicoId);                 
    });        
    setservicos(lstAdd); 
  }
  const loadSelectPacoteView = (estabelecimentoPacotes) =>{        
    if(estabelecimentoPacotes===null)
        return;

    setlistSelectPacotesSelected(estabelecimentoPacotes);

    let lstAdd = [];
    estabelecimentoPacotes.map(item =>{
        lstAdd.push(item.pacoteId);                 
    });        
    setpacotes(lstAdd); 
  }

  const loadDataCsvProdutos = () =>{

    const promise = new Promise((resolve, reject)=>{
      let exportCSV= [];

      listSelectProdutos.filter(({produtoId}) => produtos.indexOf(produtoId) != -1).map(m =>
      {
        exportCSV.push({
          estabelecimento: dadosEstabelecimento.descricao,
          tipo: 'Produto',
          descricao:m.descricao,
          valor:  "R$" + (m.valor).toFixed(2).replace('.',',')
        })
      })
      listSelectServicos.filter(({servicoId}) => servicos.indexOf(servicoId) != -1).map(s =>
        {
          exportCSV.push({
            estabelecimento: dadosEstabelecimento.descricao,
            tipo: 'Servico',
            descricao:s.descricao,
            valor:  "R$" + (s.valor).toFixed(2).replace('.',',')
          })
        })
        listSelectPacotes.filter(({pacoteId}) => pacotes.indexOf(pacoteId) != -1).map(p =>
          {
            exportCSV.push({
              estabelecimento: dadosEstabelecimento.descricao,
              tipo: 'Pacote',
              descricao:p.descricao,
              valor:  "R$" + (p.valor).toFixed(2).replace('.',',')
            })
          })
      resolve(exportCSV);
    });
    return promise;
  }
  
  const columnsCSV = [
    {id: 'estabelecimento', displayName: 'Estabelecimento'}, 
    {id: 'tipo', displayName: 'Tipo'}, 
    {id: 'descricao', displayName: 'Descrição'},
    {id: 'valor', displayName: 'Valor'}
  ];

  const onSubmit = (data, e) => {   
    e.preventDefault();
    
    if(!item.estabelecimentoId)
    {
      showNotification(t('error_message.fill_in_the_details_of_the_establishment_and_then_inform_sales_data'),'danger');
      return false;
    }

    if(listSelectEspecialidadesSelected.length === 0 && listSelectProdutosSelected.length === 0 && listSelectServicosSelected.length === 0 && listSelectPacotesSelected.length === 0)
    {
      showNotification(t('error_message.select_at_least_1_product_or_1_service_or_1_package'),'danger');
      return false;
    }

    let estabelecimento = {
      ...item,
      estabelecimentoId: item.estabelecimentoId,
      estabelecimentoEspecialidades: listSelectEspecialidadesSelected,
      estabelecimentoProdutos: listSelectProdutosSelected,
      estabelecimentoServicos: listSelectServicosSelected,
      estabelecimentoPacotes: listSelectPacotesSelected,
      percentualMaximoLimiteDesconto: transformValueFormatedtoFloat(data.percentualMaximoLimiteDesconto),
      percentualMaximoLimiteServico: transformValueFormatedtoFloat(data.percentualMaximoLimiteServico),
      percentualMaximoLimitePacote: transformValueFormatedtoFloat(data.percentualMaximoLimitePacote),
    }

    setLoading(true);
    let endPoint = "estabelecimentos/atualizavendas/"
    UsePutApi(endPoint,estabelecimento.estabelecimentoId + "/" + session.id, estabelecimento).then(result=>{
      if(result.status !== 200)
      {                                    
        showNotification(result.message,'danger');
        setLoading(false);
        return false; 
      } 
      CallUpdateItem(result.data);
      showNotification(result.message,'success');
      setLoading(false);
      return true;                 
    });
  } 
 
  return (
    <div style={{width:'100%',padding:'20px'}}>
    <form onSubmit={handleSubmit(onSubmit)}>    

    <GridContainer>
      <br />
      <GridItem xs={12} sm={12} md={12}>
        <div className="subTitulo"> 
          <h6>{t('label.discount_limit')} </h6>           
         </div>
      </GridItem>
      <GridItem xs={12} sm={4} md={4}>
        <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.percentualMaximoLimiteDesconto?true:false}
                label={'%  Máximo Limite de Desconto Produto'}
                variant="outlined"
                inputRef={register({ required: true })}
                name="percentualMaximoLimiteDesconto"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 10}}      
                InputProps={{ inputComponent: MaskMoney}}
            />
            {
              errors.percentualMaximoLimiteDesconto && 
              <FormHelperText className={classes.labelRootError}>
                  <span>{t('label.required')} </span>
              </FormHelperText>
            }
          </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4}>
        <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.percentualMaximoLimiteServico?true:false}
                label={'%  Máximo Limite de Desconto Serviço'}
                variant="outlined"
                inputRef={register({ required: true })}
                name="percentualMaximoLimiteServico"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 10}}      
                InputProps={{ inputComponent: MaskMoney}}
            />
            {
              errors.percentualMaximoLimiteServico && 
              <FormHelperText className={classes.labelRootError}>
                  <span>{t('label.required')} </span>
              </FormHelperText>
            }
          </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4}>
        <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.percentualMaximoLimitePacote?true:false}
                label={'%  Máximo Limite de Desconto Pacote'}
                variant="outlined"
                inputRef={register({ required: true })}
                name="percentualMaximoLimitePacote"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 10}}      
                InputProps={{ inputComponent: MaskMoney}}
            />
            {
              errors.percentualMaximoLimitePacote && 
              <FormHelperText className={classes.labelRootError}>
                  <span>{t('label.required')} </span>
              </FormHelperText>
            }
          </FormControl>
      </GridItem>
    </GridContainer>

    <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
          <h6>{t('label.released_specialties')} </h6>           
         </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>     
        <FormControl fullWidth className={classes.formControl}>  

          <label className={errors.produtos?"select__label select__label_error":"select__label"}>
            Especialidades </label>
            {loadComplete && <div className="loadingitemVenda">
                <CircularProgress size={20}  />
            </div>}
            {!loadComplete &&
            <Select
                classNamePrefix="select"  
                isSearchable={true}
                placeholder={t('label.select')+"..."}
                isMulti={true}    
                name="especialidades"                                  
                isLoading={loadingSelectEspecialidades}
                options={listSelectEspecialidades}     
                getOptionLabel={option =>
                  option.descricao
                }
                getOptionValue={({especialidadeId}) => especialidadeId} 
                value={listSelectEspecialidades.filter(({especialidadeId}) => especialidades.indexOf(especialidadeId) != -1)}
                onChange={(value) => handleEspecialidadeChange(value || [])}                                      
                ref={() => register( { name: "especialidades" }) }
            />
              }
           {errors.especialidades && <FormHelperText className={classes.labelRootError}>
             <span> {t('label.select_a_specialty')} </span>
          </FormHelperText> } 

          <a href="#"  onClick={() => handleClickSelecionarTodosEspecialidades()} style={{marginTop:'10px'}}>
            {t('label.select_all_specialties')}
          </a>

          </FormControl> 

        </GridItem>
      </GridContainer>
        <div>
            <div style={{float:'right'}}>
            <CsvDownloader
            filename="report"
             columns={columnsCSV}
            datas={loadDataCsvProdutos}
            separator={";"}>
                <Button  round color="default" size="sm">CSV</Button> 
            </CsvDownloader>
            </div><div style={{clear:'both'}}></div>
        </div>
      
      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
          <h6>{t('label.released_products')} </h6>           
         </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>     
        <FormControl fullWidth className={classes.formControl}>  

          <label className={errors.produtos?"select__label select__label_error":"select__label"}>
            Produtos </label>
            {loadComplete && <div className="loadingitemVenda">
                <CircularProgress size={20}  />
            </div>}
            {!loadComplete &&
            <Select
                classNamePrefix="select"  
                isSearchable={true}
                placeholder={t('label.select')+"..."}
                isMulti={true}    
                name="produtos"                                  
                isLoading={loadingSelectProdutos}
                options={listSelectProdutos}     
                getOptionLabel={option =>
                  `${option.descricao +" ("} ${option.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) +")"}`
                }
                getOptionValue={({produtoId}) => produtoId} 
                value={listSelectProdutos.filter(({produtoId}) => produtos.indexOf(produtoId) != -1)}
                onChange={(value) => handleProdutoChange(value || [])}                                      
                ref={() => register( { name: "produtos" }) }
            />
              }
           {errors.produtos && <FormHelperText className={classes.labelRootError}>
             <span> {t('label.select_a_product')} </span>
          </FormHelperText> } 

          <a href="#"  onClick={() => handleClickSelecionarTodosProdutos()} style={{marginTop:'10px'}}>
            {t('label.select_all_products')}
          </a>

          </FormControl> 

        </GridItem>
      </GridContainer>

      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
          <h6>{t('label.released_services')}</h6>
         </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>     
        <FormControl fullWidth className={classes.formControl}>  

          <label className={errors.servicos?"select__label select__label_error":"select__label"}>
            {t('label.services')} </label>
            
          {loadComplete && <div className="loadingitemVenda">
              <CircularProgress size={20}  />
          </div>}
          {!loadComplete &&
          <Select
              classNamePrefix="select"  
              isSearchable={true}
              placeholder={t('label.select')+"..."}
              isMulti={true}    
              name="servicos"                                  
              isLoading={loadingSelectServicos}
              options={listSelectServicos}     
              getOptionLabel={option =>
                `${option.descricao +" ("} ${option.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) +")"}`
              }
              getOptionValue={({servicoId}) => servicoId} 
              value={listSelectServicos.filter(({servicoId}) => servicos.indexOf(servicoId) != -1)}
              onChange={(value) => handleServicoChange(value || [])}                                      
              ref={() => register( { name: "servicos" }) }
          />
          }
           {errors.servicos && <FormHelperText className={classes.labelRootError}>
             <span> {t('label.select_an_establishment')} </span>
          </FormHelperText> } 
          
          <a href="#"  onClick={() => handleClickSelecionarTodosServicos()} style={{marginTop:'10px'}}>
            {t('label.select_all_services')}
          </a>
          </FormControl> 

        </GridItem>      
      </GridContainer>

      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
           <h6>{t('label.released_packages')} </h6>
         </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>     
        <FormControl fullWidth className={classes.formControl}>  

          <label className={errors.pacotes?"select__label select__label_error":"select__label"}>
          {t('dashboard.packages')}  </label>
            
          {loadComplete && <div className="loadingitemVenda">
              <CircularProgress size={20}  />
          </div>}
          {!loadComplete &&
          <Select
              classNamePrefix="select"  
              isSearchable={true}
              placeholder={t('label.select')+"..."}
              isMulti={true}    
              name="pacotes"                                  
              isLoading={loadingSelectPacotes}
              options={listSelectPacotes}     
              getOptionLabel={option =>
                `${option.descricao +" ("} ${option.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) +")"}`
              }
              getOptionValue={({pacoteId}) => pacoteId} 
              value={listSelectPacotes.filter(({pacoteId}) => pacotes.indexOf(pacoteId) != -1)}
              onChange={(value) => handlePacoteChange(value || [])}                                      
              ref={() => register( { name: "pacotes" }) }
          />
          }
           {errors.pacotes && <FormHelperText className={classes.labelRootError}>
             <span> {t('label.select_an_establishment')} </span>
          </FormHelperText> } 
          
          <a href="#"  onClick={() => handleClickSelecionarTodosPacotes()} style={{marginTop:'10px'}}>
            {t('label.select_all_packages')}
          </a>
          </FormControl> 

        </GridItem>        
      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>  
         <center>  <br/><br/> 
         {notification.show &&
          <SnackbarContent
            message={notification.message}
            color={notification.color}
            closeNotification={() => setNotification({show:false})}
            close
          />}
          <Button onClick={() => CallHandleVoltar()} color="transparent" >
              {t('label.return')}
          </Button>
          <Button type="submit" color="primary" >
              {t('button.to_save')}
              {loading && <div> ...{t('label.loading')} </div>}
          </Button>
          </center>  
        </GridItem>
      </GridContainer>  
  
    </form>
  </div>
  );
}